export const urls = {
  // get
  GET_VRSTE_KVARA: 'Combo/vrati_vrste_kvarova_za_tip_masine_combo',
  GET_STATUS: 'Combo/vrati_statuse_masina_combo',
  // post
  INSERT_ZAHTEV: 'DokServisniZahtevi/unos_dok_servisni_zahtev',
  UPDATE_ZAHTEV: 'DokServisniZahtevi/izmena_dok_servisni_zahtev',
  DELETE_ZAHTEV: 'DokServisniZahtevi/brisanje_dok_servisni_zahtev',
  GET_ZAHTEVE_ZA_MASINU:
    'DokServisniZahtevi/vrati_dok_servisne_zahteve_za_masinu',
  GET_ZAHTEVE_ZA_ID: 'DokServisniZahtevi/vrati_dok_servisni_zahtev_za_id',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
  DOWNLOAD_DOKUMENT:
    'Dokumenta/konvertovanje_base64_sa_id_dokumenta_servisnog_zahteva',
  SET_READ: 'DokServisniZahtevi/servisni_zahtevi_update_procitan',
};
